module.exports = __webpack_public_path__ + "static/Liegeville-f3c51f0820871287edb70b9abeb5d743.svg";